// 运行时开关，读取 public/config.js 中的 window.global_config.overseas
export const isOverseas = !!(window.global_config && window.global_config.overseas)

// 价格符号：海外显示美元，否则人民币
export const priceSymbol = isOverseas ? '$' : '¥'
